<script setup lang="ts">
import { faArrowUp } from '@fortawesome/duotone-regular-svg-icons'
import Button from '~/components/ui/Button.vue'
import Spinner from '~/components/ui/AuSpinner.vue'

defineProps<{
  isLoading: boolean
  isStreaming: boolean
  isInteracting: boolean
  disabled?: boolean
}>()

defineEmits<{
  submit: []
}>()
</script>

<template>
  <Button
    shape="square"
    size="lg"
    class="bg-(--theme-40,var(--color-seagreen-40)) text-(--theme-5,var(--color-seagreen-5))"
    :disabled="disabled || isLoading || isStreaming || isInteracting"
    @mousedown.prevent="$emit('submit')"
  >
    <Spinner
      v-if="isStreaming || isLoading"
      size="sm"
      color="var(--color-seagreen-5)"
    />
    <font-awesome-icon
      v-else
      :icon="faArrowUp"
      :bounce="isInteracting"
    />
  </Button>
</template>
